import script from "./BoardViewPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardViewPopup.vue?vue&type=script&setup=true&lang=ts"

import "./BoardViewPopup.vue?vue&type=style&index=0&id=0045379e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0045379e"]])

export default __exports__